import React, { useEffect, useMemo, useState } from 'react';
import { Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Select from 'react-select';
import { ContactUs } from '../../models/APIModels';
import { Controller, useForm } from 'react-hook-form';
import { ApiHelper } from '../../common/ApiHelper';
import Button from '../Button';
import clientUtils from '../../Utils/clientUtils';

interface IProps {
  open: boolean;
  close: () => void;
  PreSelectOptionNumber?: number;
}

const topics = [
  {
    id: 'general',
    value: 'General Information',
    label: 'General Information',
  },
  {
    id: 'bugreport',
    value: 'Bug Report',
    label: 'Bug Report',
  },
  {
    id: 'subscriptioninformation',
    value: 'Subscription Information',
    label: 'Subscription Information',
  },
];


const ContactUsModal = ({ open, close, PreSelectOptionNumber }: IProps) => {
  const [topic, setTopic] = useState(topics[PreSelectOptionNumber ? PreSelectOptionNumber - 1 : 0]);
  const { register, control, setValue, handleSubmit } = useForm<ContactUs>({});
  const handleChange = (selected: any) => {
    if (selected) setValue('topic', selected.value);
  };
  const onSubmit = async (data: ContactUs) => {
    if (data && !data.topic) {
      const index =  PreSelectOptionNumber ? !clientUtils.isEmpty(PreSelectOptionNumber) ? PreSelectOptionNumber - 1 : 0 : 0;
      data.topic = topics[index].value;
    }
    const response = await ApiHelper.ContactUs(data);
    if (response) {
      alert('Success');
      close();
    }
  };
  return (
    <div>
      <Modal isOpen={open} fade={false} toggle={close}>
        <Form className="form" onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader toggle={close}>Contact Us</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="subject">Topic</Label>
              <Select options={topics} onChange={handleChange} defaultValue={topic} />
            </FormGroup>
            <Controller
              control={control}
              name="email"
              render={({ field: { ref, ...fieldProps } }) => (
                <FormGroup>
                  <Label for="repositoryDescription">Email</Label>
                  <Input type="text" id="repositoryDescription" innerRef={ref} {...fieldProps} />
                </FormGroup>
              )}
            />
            <Controller
              control={control}
              name="message"
              render={({ field: { ref, ...fieldProps } }) => (
                <FormGroup>
                  <Label for="repositoryDescription">Message</Label>
                  <Input type="textarea" id="message" innerRef={ref} {...fieldProps} />
                </FormGroup>
              )}
            />
          </ModalBody>
          <ModalFooter>
            <Button variant="contained" rounded type="submit">
              Submit
            </Button>
            <Button variant="contained" rounded onClick={close}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default ContactUsModal;
